import { useAuth } from './context';

/**
 * A Hook that should be used only when you are 100% sure
 * under a valid user inside the Auth state
 */
export function useUser() {
  const { data } = useAuth();

  if (!data) throw new Error('useUser has been used outside user certainty');

  return data.user;
}

/**
 * A Hook that should be used only when you are 100% sure
 * under a valid user inside the Auth state
 */
export function useDashboard() {
  const { data, updateUser } = useAuth();

  if (!data) throw new Error('useDashboard has been used outside user certainty');

  return [data, { updateUser }] as const;
}
